enum PregnancyType {
    Singleton = "Singleton",
    Twin = "Twin",
    Multiple = "Multiple" // 3+
}

export { PregnancyType };
